export const ERRORS = {
	isActive: 'This account is inactive',
	GENERIC_ERROR_MESSAGE:
		'Something went wrong. Please try again later or contact our support team at hello@glazeprosthetics.com',
};
